import React from 'react';
import './pre-navbar.css';

const PreNavbar = () => {
  const handleWhatsAppClick = () => {
    // Efecto de feedback táctil
    const link = document.querySelector('.whatsapp-link');
    if (link) {
      link.style.transform = 'scale(0.95)';
      setTimeout(() => {
        link.style.transform = 'scale(1)';
      }, 150);
    }
    
    // Abrir WhatsApp
    window.open('https://wa.me/593988024805', '_blank');
  };

  return (
    <div className="elegant-prenavbar">
      <div className="prenavbar-content">
        <span>📍 Cuenca Ecuador</span>
        <span className="separator">|</span>
        <span 
          className="whatsapp-link"
          onClick={handleWhatsAppClick}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleWhatsAppClick();
            }
          }}
          aria-label="Contactar por WhatsApp al número 0988024805"
        >
          📱 0988024805
        </span>
        <span className="separator">|</span>
        <span>🚚 Envíos a todo el país</span>
      </div>
    </div>
  );
};

export default PreNavbar;